







































import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Customer } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { customerService } from "@/services/customer";

export default defineComponent({
    name: "customersTable",
    props: {},
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router } = useRouter(context);

        const customers = ref<Customer[]>([]);
        const loading = ref(false);

        (async () => {
            loading.value = true;
            customers.value = await customerService.find();
            loading.value = false;
        })();

        const tableConfig: DataTableConfig<Customer> = {
            clickItemCallback: (item) => {
                router.push({
                    name: "customer",
                    params: {
                        customerId: item.id.toString(),
                    },
                });
            },
            items: customers,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
